module.exports = __webpack_public_path__ + "static/media/achievement-29.045d1af3.png";